import type { ScenarioCalendarBasis } from "@opus-dt/shared-types";
import { Pill } from "@/components/ui/pill";
import { calendarBasisLabel } from "./basis-label";

// O rótulo da base de expediente, ao lado do botão de
// calendário e não dentro dele: quem precisa saber sobre qual jornada o resultado foi calculado
// não deveria ter de abrir a configuração do cenário para descobrir.
// As horas ao lado ("12h corridas · 8h operacionais") já dizem que HÁ expediente; só este rótulo
// diz QUAL — a diferença entre um resultado comparável com o indicador da linha e um que não é.
export function CalendarBasisPill({ basis }: { basis: ScenarioCalendarBasis }) {
  const { label, description, tone } = calendarBasisLabel(basis);
  // `withDot` porque status nunca vai só por cor (convenção do design system) — e aqui a cor
  // carrega um aviso real: o contínuo é o único regime que não corresponde a expediente nenhum.
  return (
    <Pill tone={tone} withDot title={description} aria-label={description}>
      {label}
    </Pill>
  );
}
